import { z } from 'zod';

/** Public Phase 5 invitation and realtime contracts (§26, §54, §64). */

export const joinSessionSchema = z.object({
  displayName: z.string().trim().min(2).max(80),
});
export type JoinSessionInput = z.infer<typeof joinSessionSchema>;

export const joinSessionRoomSchema = z.object({
  sessionId: z.string().min(1),
  guestToken: z.string().min(32).optional(),
});
export type JoinSessionRoomInput = z.infer<typeof joinSessionRoomSchema>;
